<template lang="pug">
    v-card#ola
        crud-data-table(
            no-detail
            no-search
            no-filter
            no-pagination
            show-native-pagination
            v-bind='tableProps'
            v-model='table.items'
            @remove='submitTableRemove' 
        )
            template( slot='items' )
                v-btn(
                    color='primary'
                    @click='showDialog'
                    v-if="$can('EDIT_EMPLOYEE')"
                    ) agregar carga familiar&nbsp;
                    v-icon add
        crud-dialog( v-bind='dialogProps' v-model='dialog' )
            crud-form( no-padding ref='form' v-bind='formProps' @submitForm='submitDialog' )
</template>

<script>
//
import { mapActions, mapState } from 'vuex'
import { CrudForm } from '@/components/reusable_components'
import {
    CrudDialog,
    ModelDataTable,
} from '@/components/reusable_components/next'
import { EmployeeDialogPicker } from '@/components/dialogs/employee'
//
import EmployeeService from '@/services/api/employee'
import FamilyBurdenService from '@/services/api/familyBurden'
//
export default {
    components: {
        'crud-data-table': ModelDataTable,
        'crud-dialog': CrudDialog,
        'crud-form': CrudForm,
        'v-dialog-picker-employee': EmployeeDialogPicker,
    },
    computed: {
        /**
         *
         */
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),

        /**
         *
         */
        dialogProps() {
            return {
                title: 'Agregar carga familiar',
                width: 1080,
            }
        },

        /**
         *
         */
        formProps() {
            return {
                fields: [
                    {
                        field: 'rut',
                        flex: {
                            xs4: true,
                        },
                        type: 'rut',
                        vuetifyProps: {
                            label: 'RUT',
                            textFieldProps: {
                                label: 'RUT',
                                outline: true,
                            },
                        },
                        rules: ['required'],
                        value: '',
                    },
                    {
                        field: 'name',
                        flex: {
                            xs4: true,
                        },
                        type: 'text',
                        vuetifyProps: {
                            label: 'Nombre',
                            textFieldProps: {
                                label: 'RUT',
                                outline: true,
                            },
                        },
                        rules: ['required'],
                        value: '',
                    },
                    {
                        field: 'hr_previred_family_burden_type_id',
                        flex: {
                            xs4: true,
                        },
                        type: 'autocompleteObject',
                        vuetifyProps: {
                            label: 'Tipo',
                            textFieldProps: {
                                label: 'RUT',
                                outline: true,
                            },
                        },
                        options: {
                            data: [
                                {
                                    text: 'Carga Simple',
                                    value: '1',
                                },
                                {
                                    text: 'Carga Maternal',
                                    value: '2',
                                },
                                {
                                    text: 'Carga Invalida',
                                    value: '3',
                                },
                            ],
                        },
                        rules: ['required'],
                        value: '',
                    },
                ],
                showLabels: false,
                submitText: 'agregar',
            }
        },

        /**
         *
         */
        tableProps() {
            return {
                ...this.table,
                noDataText: 'Sin carga familiar.',
                rowsPerPageText: 'Cargas familiares por pagina',
            }
        },
    },
    data() {
        return {
            dialog: false,
            table: {
                headers: [
                    { text: 'RUT', format: 'rut', value: 'rut', width: '15%' },
                    { text: 'nombre', value: 'name', width: '70%' },
                    { text: 'Creado el', value: 'created_at', width: '15%' },
                ],
                items: [],
            },
            selectedItem: null,
            selectedRut: null,
            selectedName: null,
            selectedType: null,
        }
    },
    methods: {
        /**
         *
         */
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        async reset() {
            //
            const employee = await EmployeeService.fetchById(
                this.$route.params.id
            )

            //
            this.table.items = employee.hr_family_burdens
        },

        /**
         * Shows the dialog.
         */
        showDialog() {
            this.dialog = true
            //this.$refs.form.vmodels.hr_previred_family_burden_type_id = ""
            //this.$refs.form.vmodels.name = ""
            //this.$refs.form.vmodels.rut = ""
            this.$refs.form.resetForm()
        },

        /**
         *
         */
        showSnackbar(type, title, message) {
            this.initSnackbar(this.fillSnack(type, title, message))
        },

        /**
         *
         */
        async submitAdd() {
            //
            const response = await FamilyBurdenService.create({
                hr_employee_id: this.$route.params.id,
                rut: this.selectedRut,
                name: this.selectedName,
                hr_previred_family_burden_type_id: this.selectedType,
            })

            //
            switch (response.status) {
                case 'error':
                    this.resetSnackbarState()
                    this.showSnackbar(
                        'error',
                        'Error.',
                        response.error || response.message
                    )
                    break
                case 'success':
                    this.resetSnackbarState()
                    this.showSnackbar(
                        'success',
                        'Éxito.',
                        'Carga familiar actualizada.'
                    )
                    this.reset()
                    this.dialog = false
                    break
                default:
                    break
            }
        },

        /**
         *
         */
        submitDialog(event) {
            //
            this.resetSnackbarState()
            this.setMessageConfirmSnack('agregar carga')
            this.showSnackbar('warning', '¿Desea agregar la carga familiar?')

            //
            this.selectedRut = event.rut
            this.selectedName = event.name
            this.selectedType = event.hr_previred_family_burden_type_id
        },

        /**
         *
         */
        async submitRemove() {
            //
            const response = await FamilyBurdenService.remove(this.selectedItem.id)

            //
            switch (response.status) {
                case 'error':
                    this.resetSnackbarState()
                    this.showSnackbar(
                        'error',
                        'Error.',
                        response.error || response.message
                    )
                    break
                case 'success':
                    this.resetSnackbarState()
                    this.showSnackbar(
                        'success',
                        'Éxito.',
                        'Carga familiar eliminada.'
                    )
                    this.reset()
                    break
                default:
                    break
            }
        },

        /**
         *
         */
        async submitTableRemove(event) {
            //
            this.resetSnackbarState()
            this.setMessageConfirmSnack('eliminar carga')
            this.showSnackbar('warning', '¿Desea eliminar la carga familiar?')

            //
            this.selectedItem = event.item
        },
    },
    mounted() {
        this.reset()
    },
    watch: {
        /**
         *
         */
        async responseConfirm() {
            switch (this.responseConfirm) {
                case 'agregar carga':
                    this.submitAdd()
                    break
                case 'eliminar carga':
                    this.submitRemove()
                    break
            }
        },

        /**
         *
         */
        $route() {
            this.reset()
        },
    },
}
</script>

